// Shared Tailwind class constants for list-item containers that reveal an
// "action" button (delete, edit, drag handle) only when the row is hovered.

// Plaintiff/Defendant card (CaseDefendant, CasePlaintiff). Wraps each row in
// the plaintiff/defendant list and reveals the trash/edit buttons on hover.
// `relative` must be permanent (not hover-scoped) so the absolutely-positioned
// action wrapper stays scoped to the card even when buttons are display:none.
export const plaintiffItemClasses =
    'group relative transition-[background-color] duration-300 hover:bg-border';

// The Stone frame drawn under a card's header, shared by the plaintiff/defendant
// cards, the Case Summary party cards and the Life Care Plan panels. Its top edge
// is dropped so the header above it reads as part of the same block. The Ivory fill
// is explicit: on Create Case the card sits on the Stone-tinted page panel, and the
// design keeps the card itself lighter than what is behind it.
export const partyCardFrameClasses =
    'border-4! border-surface-alt! border-t-0! p-4! bg-surface';

// The hidden-by-default action button revealed when the parent plaintiff
// item is hovered. Uses ! on bg/rounded to override the close XButton
// variant's transparent background and missing radius. `hidden!` and
// `group-hover:inline-flex!` both need `!` to beat XButton baseClasses' `inline-flex`.
// `inline-flex` (not `block`) on hover preserves the items-center/justify-center
// from baseClasses + close variant so the icon stays centered in the button.
// `shadow-lg` lifts the button visually off the row's hover bg (same `bg-border`
// color, so a shadow is the only thing separating them).
export const deleteBtnTiffClasses =
    'hidden! group-hover:inline-flex! bg-border! border-0 cursor-pointer ' +
    'rounded! shadow-lg w-10 h-10';

// Case-note bubble in the notes list/modal -- hovering reveals the trash
// icon at the top-right.
export const noteItemClasses =
    'group relative transition-[background-color] duration-300 hover:bg-border!';

export const deleteNoteBtnClasses =
    'hidden group-hover:block bg-border! border-0 cursor-pointer ' +
    'rounded! shadow-[rgba(149,157,165,0.8)_0px_5px_24px] absolute top-1 right-px';

// File-list row used by FileList, LiabilityFileUpload, TemplateFileUpload,
// and ReorderMedicalProvider. The trailing trash button is hidden until the
// row is hovered.
export const reportItemClasses =
    'group bg-surface-light py-2 px-4 rounded flex items-center ' +
    'justify-between text-content transition-[background-color] duration-300 ' +
    'mt-2 min-h-14 relative z-[1] hover:bg-border';

// `hidden!`/`group-hover:inline-flex!` both need `!` to beat XButton baseClasses'
// `inline-flex`. `inline-flex` (not `block`) on hover keeps items-center/justify-center
// active so the icon stays centered. `shadow-lg` lifts the button off the row's
// hover bg (same `bg-border` color, so a shadow is the only thing separating them).
export const deleteBtnClasses =
    'hidden! group-hover:inline-flex! bg-border! border-0 cursor-pointer ' +
    'rounded! shadow-lg w-10 h-10';

// Header row used above a list of report-items (file lists). The single
// child <span> gets bumped up to the 20px label size used in the design.
export const reportBtnClasses =
    'flex justify-between items-center text-content ' +
    '[&_span]:text-xl [&_span]:font-semibold';
